export default {"src":"/_next/static/media/crunchbase-logo.91ed00cb.svg","height":14,"width":105,"blurWidth":0,"blurHeight":0};